import * as url from 'url';
import * as repo from './versions-repository';
import * as ui from './ui';

/**
 * Downloads the file at url into the given local destination.
 * @param  {string} url         - Absolute url to a remote file
 * @param  {string} destination - Absolute URI to a local path
 * @return {Promise.<void>}
 */
function downloadFile(_url, destination) {
    return new Promise((resolve, reject) => {
        const done = (entry) => {
            console.debug(`Downloaded url ${_url} to ${entry.toURL()}`);
            resolve();
        }
        const fileTransfer = new FileTransfer();
        let trustAllHosts = __DEV__;

        console.debug(`Downloading url ${_url} to ${destination}`);
        fileTransfer.download(_url, destination, done, reject, trustAllHosts);
    })
}

/**
 * Returns the URI of the local path where the given version is installed
 * (or should be installed on).
 *
 * @param  {string} version
 * @return {string}
 */
function getInstallationPathForVersion(version) {
    return url.resolve(cordova.file.dataDirectory, `versions/${version}/`);
}

/**
 * Downloads the provided version spec, saves it to the cordova persistent
 * application file system, and updates the path where the version is installed
 * on the local versions repository.
 *
 * @param  {VersionSpec} versionSpec
 * @return {Promise.<void>}
 */
export async function installVersion(versionSpec) {
    /** @type {string} The semver string fo the version to intsall */
    const version = versionSpec.version;
    /** @type {string} Base URL of the remote files to download */
    const remoteRoot = versionSpec.root;
    /** @type {string} Base URI of the local directory where files will be saved */
    const localRoot = getInstallationPathForVersion(version);

    console.debug('Installing version spec:', versionSpec);

    const totalFiles = versionSpec.files;
    let downloadedFiles = 0;

    // Map every file of the version to a promise that will be resolved after
    // said file has been download and written locally
    const files = versionSpec.files.map((relPath) => {
        const remoteUrl = url.resolve(remoteRoot, relPath);
        const localUrl = url.resolve(localRoot, relPath);
        return downloadFile(remoteUrl, localUrl)
            .then(() => ui.setProgress(++downloadedFiles / totalFiles));
    });

    await Promise.all(files);

    // Update the repository where the installation path is stored
    await repo.setVersionInstallationPath(version, url.resolve(localRoot, 'index.html'));
}



// WEBPACK FOOTER //
// ./src/shared/childupp-auto-update/cordova-auto-update/install-helper.js